module.exports = __webpack_public_path__ + "img/electronic_no_zone_selected.62fb49fc.svg";